// extracted by mini-css-extract-plugin
export default {"custom_loader":"Loader_custom_loader__btM6x","loader_inner":"Loader_loader_inner__g9XUN","loading":"Loader_loading__BtKRp"};